/* Runtime du clone Furly (Velora Paws) — les scripts GemPages du concurrent sont
   retirés au build, donc tout ce qui est interactif est recâblé ici.
   window.TC_PRODUCT = {id, variants} est injecté par la section via Liquid. */
(function () {
  "use strict";

  var ROOT = document.querySelector(".tc-clone");
  if (!ROOT) return;
  var $ = function (s, c) { return (c || ROOT).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || ROOT).querySelectorAll(s)); };

  /* ---------------------------------------------------------------- reveal
     Le thème masque les éléments animés tant que son JS n'a pas posé la classe
     « vu ». Notre section n'est pas dans son cycle : on force la révélation. */
  function forceReveal() {
    $$("[class*='animate--hidden'],.animate-item,.scroll-trigger").forEach(function (el) {
      el.classList.remove("animate--hidden", "scroll-trigger--offscreen");
      el.classList.add("animate--shown");
      el.style.opacity = "";
      el.style.transform = "";
    });
  }

  /* ------------------------------------------------------------ accordéons
     GemPages : .gp-accordion-item > .gp-accordion-item_header + ._body
     Fermé = grid-template-rows 0fr, ouvert = 1fr (le CSS gère la transition). */
  function initAccordions() {
    $$(".gp-accordion-item").forEach(function (item) {
      var head = $(".gp-accordion-item_header", item);
      var body = $(".gp-accordion-item_body", item);
      if (!head || !body || item.dataset.tcBound) return;
      item.dataset.tcBound = "1";
      if (!body.style.gridTemplateRows) body.style.gridTemplateRows = "0fr";
      head.setAttribute("role", "button");
      head.setAttribute("tabindex", "0");
      head.setAttribute("aria-expanded", "false");

      var toggle = function () {
        var open = body.style.gridTemplateRows === "1fr";
        body.style.gridTemplateRows = open ? "0fr" : "1fr";
        head.setAttribute("aria-expanded", String(!open));
        item.classList.toggle("gp-accordion-item--open", !open);
        var icon = $(".gp-accordion-item_icon", item);
        if (icon) {
          icon.style.transform = open ? "" : "rotate(45deg)";
          icon.style.transition = "transform .2s ease";
        }
      };
      head.addEventListener("click", toggle);
      head.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggle(); }
      });
    });
  }

  /* --------------------------------------------------- degel du responsive
     La capture a ete faite en 1440 px : les scripts GemPages avaient alors
     ecrit en style inline les valeurs du desktop — « display:flex !important »
     sur les fleches que le mobile doit cacher, et « width:1270px !important »
     sur les pistes de carrousel. Ces valeurs inline battent toutes les regles
     @media, donc en mobile chaque diapo faisait 1270 px : videos geantes,
     cartes d'avis coupees, page 4 000 px trop longue.
     On retire ces declarations : les classes « mobile:… » et les variables
     --d-mobile / --minw-mobile du concurrent reprennent la main, et le rendu
     redevient celui de sa page a toutes les largeurs. */
  function unfreezeResponsive() {
    $$('[style*="--d-mobile:"], [style*="--d-tablet:"]').forEach(function (el) {
      if (el.style.display) el.style.removeProperty("display");
    });
    $$(".gem-slider-wrapper, .swiper-wrapper").forEach(function (track) {
      if (track.style.width) track.style.removeProperty("width");
      $$(".gem-slider-item, .swiper-slide", track).forEach(function (s) {
        if (s.style.width) s.style.removeProperty("width");
      });
    });
  }

  /* ------------------------------------------------------------- carrousels
     Les pistes Swiper sont figées par un transform inline. On les repasse en
     défilement natif avec scroll-snap et on recâble flèches + pastilles. */
  function initCarousels() {
    // On part des pistes elles-mêmes : leur classe porte l'id du carrousel
    // (gp-carousel-slider-XXXX), et les flèches/pastilles vivent hors du nœud
    // <gp-carousel-v3>, avec ce même id dans leur classe.
    $$(".gem-slider-wrapper, .swiper-wrapper").forEach(function (track) {
      if (track.dataset.tcDone) return;
      track.dataset.tcDone = "1";

      $$(".swiper-slide-duplicate, [class*='--clone']", track).forEach(function (n) { n.remove(); });

      track.style.transform = "none";
      track.style.overflowX = "auto";
      track.style.scrollBehavior = "smooth";
      track.style.scrollbarWidth = "none";
      $$(".gem-slider-item, .swiper-slide", track).forEach(function (s) {
        s.style.flex = "0 0 auto";
      });

      var m = /gp-carousel-slider-([A-Za-z0-9_-]+)/.exec(track.className);
      var cid = m ? m[1] : null;
      var step = function () {
        var first = track.querySelector(".gem-slider-item, .swiper-slide");
        return first ? first.getBoundingClientRect().width + 16 : track.clientWidth;
      };
      var pick = function (sel) {
        var all = $$(sel);
        if (!cid) return all;
        var mine = all.filter(function (b) { return b.className.indexOf(cid) !== -1; });
        return mine.length ? mine : [];
      };

      // Défilement : assignation directe de scrollLeft, relue à chaque clic.
      // (Les variantes « scrollTo/scrollBy + smooth » et le tween rAF se faisaient
      //  avaler par l'animation en cours et la flèche paraissait morte.)
      track.style.scrollBehavior = "smooth";
      var go = function (dir) {
        var s = step() || track.clientWidth;
        var max = track.scrollWidth - track.clientWidth;
        var target = Math.max(0, Math.min(max, track.scrollLeft + dir * s));
        track.scrollLeft = target;
      };
      pick(".gp-carousel-action-back, .gem-slider-previous").forEach(function (b) {
        if (b.dataset.tcBound) return;
        b.dataset.tcBound = "1";
        b.addEventListener("click", function (e) {
          e.preventDefault(); e.stopPropagation(); go(-1);
        });
      });
      pick(".gp-carousel-action-next, .gem-slider-next").forEach(function (b) {
        if (b.dataset.tcBound) return;
        b.dataset.tcBound = "1";
        b.addEventListener("click", function (e) {
          e.preventDefault(); e.stopPropagation(); go(1);
        });
      });
      // Pastilles : GemPages les fabriquait a l'execution, donc nos conteneurs
      // arrivent vides. En mobile le carrousel video n'a pas de fleche (elles
      // sont masquees comme chez lui) : sans pastilles il ne reste que le
      // glissement. On les recree, une par diapo.
      pick(".gp-carousel-dot-container").forEach(function (c) {
        if (c.dataset.tcDots) return;
        c.dataset.tcDots = "1";
        var slides = $$(".gem-slider-item, .swiper-slide", track);
        if (!c.children.length && slides.length > 1) {
          c.classList.add("tc-dots");
          slides.forEach(function () {
            c.appendChild(document.createElement("span"));
          });
        }
        var dots = Array.prototype.slice.call(c.children);
        dots.forEach(function (dot, i) {
          dot.style.cursor = "pointer";
          dot.addEventListener("click", function (e) {
            e.preventDefault();
            var max = track.scrollWidth - track.clientWidth;
            track.scrollLeft = Math.max(0, Math.min(max, step() * i));
          });
        });
        var sync = function () {
          var s = step() || 1;
          var idx = Math.round(track.scrollLeft / s);
          dots.forEach(function (d, i) { d.classList.toggle("is-active", i === idx); });
        };
        sync();
        track.addEventListener("scroll", function () {
          window.clearTimeout(c._tcT);
          c._tcT = window.setTimeout(sync, 90);
        });
      });
    });
  }

  /* ------------------------------------------------------------------ vidéos
     Lecture en boucle, muette, au scroll — comme la page d'origine. */
  function initVideos() {
    var vids = $$("video");
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute("playsinline", ""); v.setAttribute("muted", "");
      v.removeAttribute("controls");
    });
    if (!("IntersectionObserver" in window)) { vids.forEach(function (v) { v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.play().catch(function () {}); }
        else { en.target.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ------------------------------------------------------------------ héros
     Galerie (miniatures) + échelle d'offres reconstruite en natif. */
  function initHero() {
    var main = document.getElementById("tc-hero-main");
    $$(".tc-thumb").forEach(function (t) {
      if (t.dataset.tcBound) return;
      t.dataset.tcBound = "1";
      t.addEventListener("click", function () {
        if (main) main.src = t.getAttribute("data-src");
        $$(".tc-thumb").forEach(function (o) { o.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });

    var offers = $$(".tc-offer");
    offers.forEach(function (o) {
      if (o.dataset.tcBound) return;
      o.dataset.tcBound = "1";
      o.addEventListener("click", function () {
        var input = o.querySelector('input[type="radio"]');
        if (!input || input.disabled) return;
        input.checked = true;
        offers.forEach(function (x) { x.classList.remove("is-active"); });
        o.classList.add("is-active");
      });
    });
  }

  /* -------------------------------------------------------------- panier
     Le formulaire cloné porte encore les ids du concurrent : on les purge et on
     pose la vraie variante. La quantité suit l'offre choisie dans le widget. */
  function initCart() {
    // le formulaire du héros est déjà correct (rendu par {% form 'product' %}) :
    // on ne recâble que d'éventuels formulaires résiduels du concurrent.
    var form = $$('form[action*="/cart/add"]').filter(function (f) {
      return f.id !== "tc-buy-form";
    })[0];
    if (!form || !window.TC_PRODUCT) return;

    form.setAttribute("action", "/cart/add");
    $$('input[name="product-id"], input[name="section-id"], input[name^="properties[__kaching"], input[name="_bundle"]', form)
      .forEach(function (n) { n.remove(); });

    var id = form.querySelector('input[name="id"]');
    if (!id) {
      id = document.createElement("input");
      id.type = "hidden"; id.name = "id";
      form.appendChild(id);
    }
    var variant = (TC_PRODUCT.variants && TC_PRODUCT.variants[0]) || null;
    id.value = variant ? variant.id : "";

    var qty = form.querySelector('input[name="quantity"]');
    if (!qty) {
      qty = document.createElement("input");
      qty.type = "hidden"; qty.name = "quantity"; qty.value = "1";
      form.appendChild(qty);
    }

    // offres groupées : une radio [data-tc-qty] pose la quantité
    $$('[data-tc-qty]').forEach(function (opt) {
      opt.addEventListener("click", function () {
        qty.value = opt.getAttribute("data-tc-qty") || "1";
        $$('[data-tc-qty]').forEach(function (o) { o.classList.remove("tc-offer--active"); });
        opt.classList.add("tc-offer--active");
      });
    });

    // tous les CTA de la page renvoient au formulaire d'achat
    $$('a[href="#tc-bundle-slot"], a[href="#"], [gp-href]').forEach(function (a) {
      if (a.dataset.tcBound) return;
      a.dataset.tcBound = "1";
      var href = a.getAttribute("gp-href") || "";
      if (href && !/^https?:\/\/(www\.)?(lumea|velora)/i.test(href)) a.removeAttribute("gp-href");
      a.addEventListener("click", function (e) {
        var box = $("#tc-bundle-slot") || form;
        if (!box) return;
        e.preventDefault();
        box.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    });
  }

  /* ------------------------------------------------- livraison estimée (J+4)
     La date d'origine était figée par leur script : on la recalcule. */
  function initDeliveryDate() {
    var MOIS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet",
                "août", "septembre", "octobre", "novembre", "décembre"];
    var d = new Date(); d.setDate(d.getDate() + 4);
    var label = d.getDate() + " " + MOIS[d.getMonth()];
    $$("[data-tc-eta]").forEach(function (el) { el.textContent = label; });
    var walker = document.createTreeWalker(ROOT, NodeFilter.SHOW_TEXT, null);
    var re = /^\s*\d{1,2}\s(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)\s*$/;
    var n;
    while ((n = walker.nextNode())) {
      if (re.test(n.nodeValue)) n.nodeValue = label;
    }
  }

  function boot() {
    try { forceReveal(); } catch (e) {}
    try { unfreezeResponsive(); } catch (e) {}
    try { initHero(); } catch (e) {}
    try { initAccordions(); } catch (e) {}
    try { initCarousels(); } catch (e) {}
    try { initVideos(); } catch (e) {}
    try { initCart(); } catch (e) {}
    try { initDeliveryDate(); } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  // le widget de bundle se monte après coup : on repasse une fois
  window.setTimeout(boot, 1200);

  // un changement de largeur (rotation, redimensionnement) peut refiger des
  // largeurs de piste : on repasse le degel, deboune.
  var rt = null;
  window.addEventListener("resize", function () {
    window.clearTimeout(rt);
    rt = window.setTimeout(function () {
      try { unfreezeResponsive(); } catch (e) {}
    }, 150);
  });
})();
